import React, { Component } from 'react';
import SimpleLayout from '../SimpleLayout'


class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    
    render() {
        return (
            <SimpleLayout >
                <div className="setup-page">
                    <div className="center-question-wrapper">
                        <div className="gif"></div>
                        <h3>PROCESSING</h3>
                        <h4>We are getting things setup!</h4>
                    </div>
                </div>
            </SimpleLayout>
        );
    }
}


export default Signup